import { RootState } from '../../../../redux/root-reducer';
import { InvitationActions, INVITATION_ACTION_TYPE } from './invitation-type';

export enum INVITATION_STATE_KEY {
  FORM = 'FORM',
  STEP = 'STEP'
}

export type InvitationStep = 'form' | 'terms' | 'success';

export type InvitationFormData = {
  contactName: string,
  contactNumber: string,
  availableTime: string,
  token: string
};

export type InvitationState = {
  [INVITATION_STATE_KEY.FORM]: InvitationFormData,
  [INVITATION_STATE_KEY.STEP]: InvitationStep
};

const initialState: InvitationState = {
  [INVITATION_STATE_KEY.FORM]: {
    contactName: '',
    contactNumber: '',
    availableTime: '09:00 - 12:00',
    token: ''
  },
  [INVITATION_STATE_KEY.STEP]: 'form'
};

export const invitationReducers = (state = initialState, action: InvitationActions) => {
  switch (action.type) {
    case INVITATION_ACTION_TYPE.SET_INVITATION_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const invitationStateSelector = (key: INVITATION_STATE_KEY) => (state: RootState) => state.invitation[key];
